import React, { Fragment, useEffect, useState } from 'react';
import Breadcrumb from '../common/breadcrumb';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import { adminInstance } from '../../config/axios';
import { Loader } from 'react-feather';
import GameTransactionHistoryTable from './listDataTable';

const GameTransactions = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const getAllHistory = async (data) => {
    setLoading(true);
    try {
      const response = await adminInstance().get(
        `api/admin/getGameTransactionHistory?skip=${data?.skip}`
      );
      if (response?.data?.code === 200) {
        setLoading(false);
        setData(response?.data?.gameHistory);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getAllHistory({ skip: 0 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {/* {loading && <Loader />} */}
      <Fragment>
        <Breadcrumb title='Game History' parent='Transaction' />
        <Container fluid={true}>
          <Row>
            <Col sm='12'>
              <Card>
                <CardHeader>
                  <h5>Game History</h5>
                </CardHeader>
                <CardBody>
                  <div id='batchDelete' className='transactions'>
                    {!loading ? (
                      <GameTransactionHistoryTable
                        multiSelectOption={true}
                        myData={data}
                        pageSize={10}
                        pagination={true}
                        class='-striped -highlight'
                      />
                    ) : (
                      <Loader />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    </>
  );
};

export default GameTransactions;
